if (location.pathname.startsWith("/embed")) {
  import("./setupEmbed.js")
} else {
  import("./setupApp.js")
}
